'use client';

import { AppSidebar } from '@/app/(app)/sidebar/sidebar';
import { CommandMenu } from '@/components/command-menu';
import { AuthProvider } from '@/components/providers/auth-provider';
import { EmployeesProvider } from '@/components/providers/employee-provider';
import { FeatureFlagProvider } from '@/components/providers/feature-flag-provider';
import { ServiceTypeTemplatesProvider } from '@/components/providers/service-templates-provider';
import { ApiV1Provider } from '@/components/providers/v1-api';
import { CustomerProvider } from '@/components/providers/v1-cutsomer-provider';
import { EmployeeMeProvider } from '@/components/providers/v1-me-provider';
import { OfficeProvider } from '@/components/providers/v1-office-provider';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ApiV1Provider>
        <EmployeeMeProvider>
          <OfficeProvider>
            <FeatureFlagProvider>
              <EmployeesProvider>
                <CustomerProvider>
                  <ServiceTypeTemplatesProvider>
                    <SidebarProvider>
                      <AppSidebar />
                      <SidebarInset>{children}</SidebarInset>
                      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                      <CommandMenu />
                    </SidebarProvider>
                  </ServiceTypeTemplatesProvider>
                </CustomerProvider>
              </EmployeesProvider>
            </FeatureFlagProvider>
          </OfficeProvider>
        </EmployeeMeProvider>
      </ApiV1Provider>
    </AuthProvider>
  );
}
